import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useSelector, useDispatch } from "react-redux";
import { listHelperMasterAsync } from "../../../../redux/features/helperMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";
import { changeStatus } from "../../../../Api/dispatch/helper-dispatch";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { useBoolean } from "../../../../Hooks/useBoolean";
import { helperMasterReportAsync } from "../../../../redux/features/reportSlice";

export default function HelperMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const helperMaster = useSelector((state) => state.helperMaster);
   const helperMasterList = helperMaster?.dataList;
   const [records, setRecords] = useState([]);

   const reportPopup = useBoolean();

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         helperMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Helper Name",
                  "Helper No.",
                  "Helper Aadhar No.",
                  "Helper DOB",
                  "Pan Card",
                  "Helper Joining Date",
                  "Helper Exit Date",
                  "Helper Salary",
                  "Helper Address",
                  "Eisaku Payroll / Contractor",
                  "Helper Account No.",
                  "Helper Account IFSC Code",
                  "Contractor commission amount",
               ];

               const driverMasterDataArr = [];

               report?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     index + 1, // S. No.
                     item?.name ?? "-", // Helper Name
                     item?.mobile ?? "-", // Helper No.
                     item?.aadhar_card ?? "-", // Helper Aadhar No.
                     item?.dob ?? "-", // Helper DOB
                     item?.pan_card ?? "-", // Pan Card
                     item?.doj ?? "-", // Helper Joining Date
                     item?.doe ?? "-", // Helper Exit Date
                     (item?.monthly_salary_amount ||
                        item?.helper_monthly_salary_amount) ??
                        "-", // Helper Salary
                     item?.address ?? "-", // Helper Address
                     item?.payroll ?? "-", // Eisaku Payroll / Contractor
                     item?.helper_account_number ?? "-", // Helper Account No.
                     item?.helper_ifsc_code ?? "-", // Helper Account IFSC Code
                     item?.monthly_salary_commission_amount ?? "-" // Contractor commission amount
                  );
                  driverMasterDataArr.push(arr);
               });

               console.log({ driverMasterDataArr });

               // Combine headers and rows
               const sheetData = [headers, ...driverMasterDataArr];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               ws["!cols"] = new Array(report?.length)?.map(() => ({ width: 1500 }));
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "HELPER_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listHelperMasterAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
   }, []);

   useEffect(() => {
      if (helperMasterList) {
         setRecords(helperMasterList);
      }
   }, [helperMasterList]);

   // Handle active inactive
   const handleActiveInactive = (helper) => {
      setIsActiveLoading({ id: helper?.id, status: true });
      changeStatus({ id: helper?.id, status: helper?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: helper?.id, status: false });
            dispatch(listHelperMasterAsync({}));
            toast.success(
               `Helper ${helper?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: helper?.id, status: false });
            toast.error(
               `Failed to ${helper?.is_active === "1" ? "deactivate" : "activate"} helper`
            );
         });
   };

   const columns = [
      {
         name: "Helper Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "DOB",
         selector: (row) => row.dob,
      },
      {
         name: "Payroll Type",
         selector: (row) => row.payroll,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/helper-master/edit/${row?.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     id="driver1"
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = helperMasterList?.filter((item) => {
         return (
            item?.name?.toLowerCase().includes(searchText) ||
            item?.payroll?.toLowerCase().includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="Helper Master List" />

         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <DownloadReportButton
                  onDownloadReport={handleDownloadReport}
                  confirmPopup={reportPopup}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
